import { useCallback, useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { getDeductionRouteDetail } from "../services";
import { DeductionRouteDetail } from "../types/deduction.type";
import { COMPACT_QUERY } from "../utils/hooks/useCompact";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DeductionDetailsSkeleton from "../components/Deduction/Details/DeductionDetailsSkeleton";
import DeductionFooter from "../components/Deduction/Details/DeductionFooter";
import RouteDetail from "../components/Deduction/RouteDetail";

const compact = "@media " + COMPACT_QUERY;

export default function DeductionRouteDetailPage() {
  const { routeUuid } = useParams<{ routeUuid: string }>();
  const [searchParams] = useSearchParams();
  const yearMonth = searchParams.get("year_month");

  const [route, setRoute] = useState<DeductionRouteDetail | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const onGetRouteDetail = useCallback(async () => {
    if (!routeUuid || !yearMonth) return;
    setLoading(true);
    try {
      const {
        data: { data },
      } = await getDeductionRouteDetail(routeUuid, dayjs(`${yearMonth}-01`));
      setRoute(data);
    } finally {
      setLoading(false);
    }
  }, [routeUuid, yearMonth]);

  useEffect(() => {
    onGetRouteDetail();
  }, [onGetRouteDetail]);

  if (loading) return <DeductionDetailsSkeleton />;

  return (
    <Box sx={{ padding: "8px 0", [compact]: { pb: "56px" } }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Link
          to="/report/deduction"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            รายงานการหักเงินพนักงาน
          </Typography>
        </Link>
        <Typography variant="body1" sx={{ mx: 1 }}>
          /
        </Typography>
        <Typography variant="body1" color="primary">
          {route?.route_code ?? "รายละเอียด"}
        </Typography>
      </Box>

      {route && <RouteDetail route={route} />}

      {route && <DeductionFooter totalAmount={route.total_amount} />}
    </Box>
  );
}
